<template>
    <v-container fluid>
        
        <InfoAlert :showDismissibleAlert="showDismissibleAlert" :info="info" v-on:close="showDismissibleAlert=false" />
        <v-card :style="{'border-radius':'5px','border':'1px solid'+$store.getters.getColorPalette().panelBorderColorCode}"  class="mx-1 my-1" flat :dark="$store.getters.getColorPalette().isDark" :color="$store.getters.getColorPalette().background2ColorCode">
<v-row>
    <v-col>
 <v-form
    ref="orgForm"
    v-model="valid"
    
  >
      <v-card flat outlined  :dark="$store.getters.getColorPalette().isDark" :color="$store.getters.getColorPalette().background2ColorCode">
        <v-card-title class="headline">
          {{ $store.getters.getTextMap().add_usage }}
        </v-card-title>
        <v-card-text>
            <v-row>
                <v-col>
                    <v-text-field
              v-model="form.param_id"
              :counter="45"
              :rules="[rules.required, rules.nonZeroLength, rules.noSpace]"
              :label="$store.getters.getTextMap().parameter_id"
              :loading="loading"
              required
            ></v-text-field>

                </v-col>
                <v-col><v-skeleton-loader
      v-if="loading"
    class="mx-auto"
    type="text"
  ></v-skeleton-loader>
              <v-menu :dark="$store.getters.getColorPalette().isDark"
           :color="$store.getters.getColorPalette().inputtextColor"
              v-if="!loading"
      v-model="menu"
      :close-on-content-click="false"
      :nudge-right="40"
      transition="scale-transition"
      offset-y
      min-width="290px"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field :dark="$store.getters.getColorPalette().isDark"
           :color="$store.getters.getColorPalette().inputtextColor"
          v-model="form.date"
          :label="$store.getters.getTextMap().date"
          prepend-icon="mdi-calendar"
          readonly
          v-bind="attrs"
          v-on="on"
          :rules="[rules.required]"
        ></v-text-field>
      </template>
      <v-date-picker :dark="$store.getters.getColorPalette().isDark"
            :color="$store.getters.getColorPalette().inputtextColor"
        v-model="form.date"
        
        @input="menu = false"
      ></v-date-picker>
    </v-menu>
</v-col>
<v-col>
    <v-text-field
              v-model="form.usage"
              :counter="45"
              :rules="[rules.required, rules.nonZeroLength, rules.noSpace, rules.num]"
              :label="$store.getters.getTextMap().value"
              :loading="loading"
              required
            ></v-text-field>
</v-col>
            </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
          :color="$store.getters.getColorPalette().submitbtnColor"
           
            @click="onSubmit"
          >
          {{$store.getters.getTextMap().submit}}
          </v-btn>
          <v-btn
           :color="$store.getters.getColorPalette().cancelbtnColor"
         :dark="$store.getters.getColorPalette().isDark" 
            @click="onReset"
          >
           {{ $store.getters.getTextMap().cancel }}
          </v-btn>
        </v-card-actions>
      </v-card>
      </v-form>
    </v-col>
</v-row>
</v-card>
    </v-container>
</template>
<script>
import axios from 'axios';
import InfoAlert from '@/components/InfoAlert'
import FormRules from '@/utillities/FormRules'
export default {
    name:'AddHub',
    components:{
        InfoAlert
    },
    data(){
        return {
            form:{
                
            },
                loading:false,
                info:null,
                showDismissibleAlert:false,
                valid:false,
                menu:null,
                rules:FormRules.rules,
        }
    },
    methods:{
        onSubmit(){
            //evt.preventDefault();
            this.$refs.orgForm.validate()
            if(this.valid){
            this.loading = true;
      axios
        .post(this.$store.state.api + "addParamDailyData", this.form,{headers: {
      Authorization: 'Bearer '+ this.$store.state.jwt
    }})
        .then(response => {
          if (response.data.status == "success") {
            
            
            //console.log(response.data.jwt);
            // this.$store.dispatch("refreshHubs");
            
           
            this.info = "Data added";
          this.showDismissibleAlert = true;
          this.loading = false;
            // this.onReset()
            this.$emit('close')
          } else {
            this.info = response.data.msg;
            this.showDismissibleAlert = true;
          }
          //this.onReset()
          this.loading = false;
        })
        .catch(error => {
        //   this.onReset()
          this.info = error;
          this.showDismissibleAlert = true;
          this.loading = false;
        });
            }
        },
        onReset(){
            this.$refs.orgForm.reset()
            
            
            
        }
    }
}
</script>
<style scoped>
.v-sheet.v-card{
  background-color:#B2DFDB;
}
</style>